module.exports = __webpack_public_path__ + "821e29b89cded40011f1376a769f3eb6.png";